interface MissingDependencyDetail {
  dependent_metric_id: string
  missing_dependency_metric_ids: string[]
  reason: "missing_metric_dependencies"
}

function maybeMissingDependencyDetail(
  candidate: unknown,
): MissingDependencyDetail | null {
  if (typeof candidate !== "object" || candidate === null) {
    return null
  }
  const record = candidate as Record<string, unknown>
  const missingIds = record.missing_dependency_metric_ids
  if (
    record.reason !== "missing_metric_dependencies" ||
    typeof record.dependent_metric_id !== "string" ||
    !Array.isArray(missingIds) ||
    !missingIds.every((id: unknown) => typeof id === "string")
  ) {
    return null
  }
  return {
    reason: "missing_metric_dependencies",
    dependent_metric_id: record.dependent_metric_id,
    missing_dependency_metric_ids: missingIds,
  }
}

/** Formats the structured AIP-193 fallback when a stale UI misses validation. */
export function formatMissingMetricDependenciesError(
  error: unknown,
  metricLabelsById: Record<string, string> = {},
): string | null {
  if (typeof error !== "object" || error === null) {
    return null
  }
  const errorRecord = error as Record<string, unknown>
  const detail = errorRecord.detail
  if (typeof detail !== "object" || detail === null) {
    return null
  }
  const detailRecord = detail as Record<string, unknown>
  if (!Array.isArray(detailRecord.details)) {
    return null
  }
  const labelFor = (id: string) => metricLabelsById[id] ?? id
  const failures = detailRecord.details
    .map(maybeMissingDependencyDetail)
    .filter(
      (candidate): candidate is MissingDependencyDetail => candidate !== null,
    )
    .map(
      (candidate) =>
        `${labelFor(candidate.dependent_metric_id)}: ${candidate.missing_dependency_metric_ids.map(labelFor).join(", ")}`,
    )
  return failures.length > 0
    ? `Select required metric dependencies: ${failures.join("; ")}`
    : null
}
